import { put, takeLatest } from 'redux-saga/effects';
import { GetLicenses } from '../../reducers/r_index';

import authService from './../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { codiceUtente } }) {
    try {

        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/GetLicenses/' + codiceUtente, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const requestResult = yield response.json();

        //creo l'array di licenze
        var lista_licenze = requestResult;

        // throw new Error("Sorry, but you are too young for this movie");
        yield put(GetLicenses.creators.getLicensesSuccess({ lista_licenze }));

    } catch (e) {
        yield put(GetLicenses.creators.getLicensesFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(GetLicenses.types.GET_LICENSES_REQUEST, runAction);
}



/* esempio risposta
 
 var lista_licenze = [
      {
        ID: '1348',
        ProductKey: '0IH3U-U8RZ5-K8DT8-MVSWC',
        SerialNumber: '53455',
        Tipologia: 'Enterprise',
        Cliente: 'MatteoB Testovd',
        DataScadenza: '2020-02-25T00:00:00+01:00',
        DataAttivazione: '2019-11-08T00:00:00+01:00',
        Bloccata: 'true',
        CodiceUtente: 'CODICEADMIN',
        SerialNumberOld: '123',
        Email: 'matteo.bissaro@vsh.it',
        HW_ID: null,
        NumeroReinstallazioni: '2',
        DataUltimoAccesso: '2019-11-25T00:00:00+01:00',
        DataCreazione: '2019-11-08T17:00:00+01:00',
        MultiAzienda: 'true',
        CodAzienda: '',
        DataDecorr: '2020-03-09T00:00:00+01:00',
        IDModulo: '267'
      },
      {
        ID: '1348',
        ProductKey: '0IH3U-U8RZ5-K8DT8-MVSWC',
        SerialNumber: '53455',
        Tipologia: 'Enterprise',
        Cliente: 'MatteoB Testovd',
        DataScadenza: '2020-02-25T00:00:00+01:00',
        DataAttivazione: '2019-11-08T00:00:00+01:00',
        Bloccata: 'true',
        CodiceUtente: 'CODICEADMIN',
        SerialNumberOld: '123',
        Email: 'matteo.bissaro@vsh.it',
        HW_ID: null,
        NumeroReinstallazioni: '2',
        DataUltimoAccesso: '2019-11-25T00:00:00+01:00',
        DataCreazione: '2019-11-08T17:00:00+01:00',
        MultiAzienda: 'true',
        CodAzienda: '',
        DataDecorr: '2020-03-19T00:00:00+01:00',
        IDModulo: '434'
      },
      {
        ID: '1536',
        ProductKey: '8Y05T-T8707-WT32V-QSSR9',
        SerialNumber: '123456',
        Tipologia: 'Enterprise',
        Cliente: null,
        DataScadenza: '2020-12-31T00:00:00+01:00',
        DataAttivazione: null,
        Bloccata: 'false',
        CodiceUtente: null,
        SerialNumberOld: null,
        Email: null,
        HW_ID: null,
        NumeroReinstallazioni: null,
        DataUltimoAccesso: null,
        DataCreazione: '2020-02-25T15:38:00+01:00',
        MultiAzienda: 'true',
        CodAzienda: '',
        DataDecorr: '2020-02-25T15:38:00+01:00',
        IDModulo: '444'
      },
      {
        ID: '1523',
        ProductKey: 'O5OXO-OT4RN-9ZF9O-4KE5S',
        SerialNumber: '154878',
        Tipologia: 'Enterprise',
        Cliente: null,
        DataScadenza: '2026-12-31T00:00:00+01:00',
        DataAttivazione: null,
        Bloccata: 'false',
        CodiceUtente: 'UTENTEPROVA',
        SerialNumberOld: null,
        Email: null,
        HW_ID: null,
        NumeroReinstallazioni: null,
        DataUltimoAccesso: null,
        DataCreazione: '2020-02-13T16:18:00+01:00',
        MultiAzienda: 'true',
        CodAzienda: '\n      ',
        DataDecorr: '2020-02-13T16:18:00+01:00',
        IDModulo: '422'
      },
      {
        ID: '2',
        ProductKey: 'FIET3-3BGYN-PYF4A-9UMPI',
        SerialNumber: '190000',
        Tipologia: 'Enterprise',
        Cliente: null,
        DataScadenza: null,
        DataAttivazione: null,
        Bloccata: 'false',
        CodiceUtente: null,
        SerialNumberOld: null,
        Email: null,
        HW_ID: null,
        NumeroReinstallazioni: null,
        DataUltimoAccesso: null,
        DataCreazione: '2019-05-02T11:51:00+02:00',
        MultiAzienda: 'false',
        CodAzienda: '',
        DataDecorr: null,
        IDModulo: '1'
      },
      {
        ID: '6',
        ProductKey: 'VSROH-H53UM-YUC3H-DWZ54',
        SerialNumber: '190001',
        Tipologia: 'Enterprise',
        Cliente: 'provacli',
        DataScadenza: null,
        DataAttivazione: null,
        Bloccata: 'false',
        CodiceUtente: 'CODICEADMIN',
        SerialNumberOld: null,
        Email: 'provamail@vsh.it',
        HW_ID: null,
        NumeroReinstallazioni: null,
        DataUltimoAccesso: null,
        DataCreazione: '2019-05-20T20:59:00+02:00',
        MultiAzienda: 'false',
        CodAzienda: '',
        DataDecorr: null,
        IDModulo: '4'
      },
      {
        ID: '7',
        ProductKey: 'ILQ31-1S3S6-ZVFMU-5DEDP',
        SerialNumber: '190002',
        Tipologia: 'Enterprise',
        Cliente: 'provacli002',
        DataScadenza: '2019-12-31T00:00:00+01:00',
        DataAttivazione: null,
        Bloccata: 'true',
        CodiceUtente: null,
        SerialNumberOld: null,
        Email: 'provamail@vsh.it',
        HW_ID: null,
        NumeroReinstallazioni: null,
        DataUltimoAccesso: null,
        DataCreazione: '2019-05-20T21:04:00+02:00',
        MultiAzienda: 'true',
        CodAzienda: '',
        DataDecorr: null,
        IDModulo: '5'
      },
      {
        ID: '1449',
        ProductKey: 'DCLQ5-54753-MT663-HN55W',
        SerialNumber: '190003',
        Tipologia: 'Enterprise',
        Cliente: null,
        DataScadenza: '2020-12-31T00:00:00+01:00',
        DataAttivazione: null,
        Bloccata: 'false',
        CodiceUtente: null,
        SerialNumberOld: null,
        Email: null,
        HW_ID: null,
        NumeroReinstallazioni: null,
        DataUltimoAccesso: null,
        DataCreazione: '2020-01-28T17:00:00+01:00',
        MultiAzienda: 'true',
        CodAzienda: '',
        DataDecorr: '2020-01-28T17:00:00+01:00',
        IDModulo: '360'
      },
      {
        ID: '1450',
        ProductKey: 'VYZPL-L1JXC-0V7M4-M6T0G',
        SerialNumber: '190004',
        Tipologia: 'Enterprise',
        Cliente: 'aaaaa',
        DataScadenza: '2020-12-31T00:00:00+01:00',
        DataAttivazione: null,
        Bloccata: 'false',
        CodiceUtente: null,
        SerialNumberOld: null,
        Email: null,
        HW_ID: null,
        NumeroReinstallazioni: null,
        DataUltimoAccesso: null,
        DataCreazione: '2020-01-28T17:02:00+01:00',
        MultiAzienda: 'true',
        CodAzienda: '',
        DataDecorr: '2020-01-28T17:02:00+01:00',
        IDModulo: '361'
      },
      {
        ID: '1401',
        ProductKey: 'VZ3CE-E75G7-HWTKE-KPHTI',
        SerialNumber: '200501',
        Tipologia: 'Enterprise',
        Cliente: null,
        DataScadenza: '2020-12-31T00:00:00+01:00',
        DataAttivazione: null,
        Bloccata: 'false',
        CodiceUtente: null,
        SerialNumberOld: '130039',
        Email: null,
        HW_ID: null,
        NumeroReinstallazioni: null,
        DataUltimoAccesso: null,
        DataCreazione: '2020-01-02T11:22:00+01:00',
        MultiAzienda: 'true',
        CodAzienda: '',
        DataDecorr: '2020-01-02T11:22:00+01:00',
        IDModulo: '320'
      }];

        */